import { cn } from '@/trailmix/lib/cn';
import { Link } from '@inertiajs/react';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';

export function SearchBarButton({ className }: { className?: string }) {
    return (
        <Link
            href={route('search.index')}
            className={cn(
                'flex h-[40px] w-full items-center rounded-md border border-gray-200 pr-4 text-gray-500 focus:outline-none focus:ring',
                className
            )}
        >
            <Icon path={mdiMagnify} className='mx-2.5 size-5' />
            Search
        </Link>
    );
}
